import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer({ onSchedule }) {
  return (
    <footer className="bg-plum text-cream">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="h-9 w-9 rounded-full bg-coral grid place-items-center text-cream font-poppins font-bold">K</span>
              <span className="font-poppins font-bold text-lg">Community Experiences by Kay</span>
            </div>
            <p className="mt-5 text-cream/70 leading-relaxed max-w-sm">
              Meaningful experiences that bring residents and families together.
              Professional photography preserves the memory.
            </p>
            <button
              data-testid="footer-schedule-btn"
              onClick={onSchedule}
              className="mt-7 rounded-full bg-coral text-cream font-semibold px-6 py-3 transition-all hover:-translate-y-0.5"
            >
              Request a 15-Minute Conversation
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <h4 className="font-poppins font-bold text-cream/90 mb-4">Get in touch</h4>
            <ul className="space-y-3 text-cream/70">
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-marigold" />
                <a data-testid="footer-email" href="mailto:hello@kwaasa.com" className="hover:text-cream transition-colors">hello@kwaasa.com</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-marigold" />
                <a data-testid="footer-phone" href="tel:+13106993664" className="hover:text-cream transition-colors">(310) 699-3664</a>
              </li>
              <li className="flex items-start gap-3"><MapPin size={18} className="text-marigold mt-0.5" /> South Bay and surrounding communities within 50 miles.</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-poppins font-bold text-cream/90 mb-4">Explore</h4>
            <ul className="space-y-3 text-cream/70">
              <li><a href="#experience" className="hover:text-cream transition-colors">The Experience</a></li>
              <li><a href="#whats-included" className="hover:text-cream transition-colors">What&rsquo;s Included</a></li>
              <li><a href="#about" className="hover:text-cream transition-colors">About Kay</a></li>
              <li><a href="#contact" className="hover:text-cream transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-cream/15 space-y-4">
          <p data-testid="privacy-statement" className="text-cream/50 text-sm max-w-3xl leading-relaxed">
            <span className="font-semibold text-cream/70">Privacy:</span> We only collect the contact details
            you choose to share so Kay can personally follow up about your inquiry. Your information is never
            sold or shared, and you may request its removal at any time.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-cream/50 text-sm">
            <p>© 2026 Community Experiences by Kay. All rights reserved.</p>
            <p data-testid="footer-brand-line" className="text-cream/60">Community Experiences by Kay, a Kwaasa experience.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
